export default "__VITE_ASSET__DrHvS8TH__"